import { create } from 'zustand';

interface AudioState {
  audioUnlocked: boolean;
  setAudioUnlocked: (value: boolean) => void;
}

export const useAudioStore = create<AudioState>((set) => ({
  audioUnlocked: false,
  setAudioUnlocked: (value) => set({ audioUnlocked: value }),
}));
